import * as ResponsiveFns from '../utilities/ResponsiveFns';
import React, {useState} from 'react';
import OwnColor from '../Editor/OwnColor';
import DistanceSelector from './DistanceSelector';
import TableGrid from './TableGrid';
import IconPicker from './IconPicker';

function App(props) {

  var currentScreenStyle = props.currentScreenStyle;
  var submitGeneric = props.submitGeneric;
  var columnWidthReal = props.columnWidth;
  var currentList = props.currentList;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var screenSize = props.screenSize;
  var mostRecentColor = props.mostRecentColor;
  var setMostRecentColor = props.setMostRecentColor;
  var organicChanges = props.organicChanges;
  var stylePath = props.stylePath;

  var currentIcon = ResponsiveFns.getOrigFn('icon', currentScreenStyle);
  if (!currentIcon){
    currentIcon = '';
  }

  const [showWhat, setShowWhat] = useState(0);


  var inside;

  if (showWhat === 0){


    function selectFn(value){
      submitGeneric({t:'raw', v:value}, 'icon', []);
    }

    inside = <IconPicker selectFn={selectFn} currentIcon={currentIcon} columnWidthReal={columnWidthReal}/> 
//
  }else if (showWhat === 1){

    var currentColor;
    if (currentScreenStyle){
      currentColor = currentScreenStyle.iconColor;
    }

    function changeColor(e){
        submitGeneric({t:'raw', v:e}, 'iconColor');
    }

    inside = <OwnColor currentList={currentList} submitColor={changeColor} currentStyle={currentColor} allowFormula={false} e={false} width={columnWidthReal} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} colorType={'iconColor'} logPath={stylePath} organicChanges={organicChanges} styles={currentScreenStyle} />    
  }else if (showWhat === 2){

    var opt = [
      {t:'Height', ic:'akar-icons:height', i:false}, 
      {t:'Width', ic:'akar-icons:width', i:'w'}, 
      {t:'H & W', ic:'el:move', i:'hw'}];

    var toDos = [{q:'Constraint', t:'samples2', opt, i:'hW'}];
    var hWChoice = false;
    if (currentScreenStyle && currentScreenStyle.hW){
      hWChoice = currentScreenStyle.hW;
    }
    if (!hWChoice || hWChoice.v === 'hw'){
      toDos.push({q:'Height', t:'distance', i:'iconHeight', u:[{t:'px', n:'Pixels'}], orig:20, min:1, max:100});
    }
    if (hWChoice && (hWChoice.v === 'w' || hWChoice.v === 'hw')){
      toDos.push({q:'Width', t:'distance', i:'iconWidth', u:[{t:'px', n:'Pixels'}], orig:20, min:1, max:100});
    }


    toDos.push({q:'Rotation', t:'distance', i:'iconRotation', u:[{t:'dc', n:'Decimals'}], orig:0, min:0, max:360});


    inside = toDos.map((aToDo, index)=>{
      var details;
      if (aToDo.t === 'distance'){
        var origDistance = aToDo.orig;
        if (currentScreenStyle && currentScreenStyle[aToDo.i]){
              origDistance = currentScreenStyle[aToDo.i].v;
        }
        function submitValueAndUnit(set){
         submitGeneric({t:set.t, v:set.v}, aToDo.i, []);
        }
       details = <DistanceSelector title={aToDo.q} changeWhat={aToDo.i} origDistance={origDistance} step={1} min={aToDo.min} max={aToDo.max} uintChoices={aToDo.u} origUnit={aToDo.u[0].t} submitValueAndUnit={submitValueAndUnit} insetWidth={insetWidth} insetHeight={insetHeight} doCombo={false} screenSize={screenSize}/> 

      }else if (aToDo.t === 'samples2'){
        function doClick(item){
            submitGeneric({t:'raw', v:item.i}, aToDo.i, []);
        }
        var orig2 = false;
        if (currentScreenStyle && currentScreenStyle[aToDo.i]){
          orig2 = currentScreenStyle[aToDo.i].v;
        }

        details = <TableGrid options={aToDo.opt} currentAnswer={orig2} onClick={doClick} />
      }

      return <div key={index}><u>{aToDo.q}</u><br/>
        {details}
        </div>

    })
  }
//
    var but = [{t:'Icon',i:0,ic:'akar-icons:image'}, {t:'Color',i:1,ic:'clarity:color-palette-solid'}, {t:'Settings',i:2,ic:'bytesize:settings'}];

      function clickShowWhat(x){
          setShowWhat(x.i);
      }

//
  return  (<center>
    <TableGrid options={but} currentAnswer={showWhat} onClick={clickShowWhat} /><br/>
    {inside}
      </center>)

}


//
export default App;
